import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Avatar } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight, faWifi, faTv, faPhone, faCheck } from "@fortawesome/pro-solid-svg-icons";

import { useAuthContext } from "../../contexts/AuthContext";
import {
    parseBoolOr,
    parseStringOr,
    moneyFormat,
} from "../../components/App/AppxUtils";


export default function PlanCard(props) {
    const { org, config } = useAuthContext();
    const { t, i18n } = useTranslation("appxweb");
    const history = useHistory();
    const channelChooseUrl = parseStringOr(config?.channelChooseUrl, "");
    let plan = props?.plan || {};
    let bgColor = parseStringOr(props.bgColor, "");
    bgColor = ["light", "dark"].indexOf(bgColor) > -1 ? bgColor : "light";
    let monthlyPrice = moneyFormat(plan.monthlyPrice, plan.currency);
    plan.monthlyPricePrint = monthlyPrice.replace(/\$/g, (match) => `<sup>${match}</sup>`);
    plan.info = parseStringOr(plan.info, "");
    plan.infoPrint = plan.info.split('\n');
    plan.infoFr = parseStringOr(plan.infoFr, "");
    plan.infoFrPrint = plan.infoFr.split('\n');
    plan.isNet = parseBoolOr(plan?.isNet, false);
    plan.isTv = parseBoolOr(plan?.isTv, false);
    plan.isVoice = parseBoolOr(plan?.isVoice, false);
    plan.planStep = parseStringOr(plan.planStep, "").toUpperCase();

    const nextStep = (apiCode, external) => {
        if (external) {
            window.location.href = `${channelChooseUrl}/${org}?planApiCode=${apiCode}&lang=${i18n.language}`;
        }
        else {
            history.push(`/?planApiCode=${apiCode}`);
        }
    }

    let planLabelField = 'label';
    let planInfoField = "infoPrint"

    if (i18n.language === 'fr') {
        planLabelField = 'labelFr';
        planInfoField = "infoFrPrint"
    }

    let darkAlt = "";
    let external = false;
    let icons = [];

    if (plan.isNet) {
        icons.push(
            <Avatar
                shape="circle"
                className="plan-card-header-icons-net"
                icon={<FontAwesomeIcon icon={faWifi} />} />
        );
    }

    if (plan.isTv) {
        icons.push(
            <Avatar
                shape="circle"
                className="plan-card-header-icons-tv"
                icon={<FontAwesomeIcon icon={faTv} />} />
        );

        external = true;
        darkAlt = "plan-card-green";
    }

    if (plan.isVoice) {
        icons.push(
            <Avatar
                shape="circle"
                className="plan-card-header-icons-voice"
                icon={<FontAwesomeIcon icon={faPhone} />} />
        );

        darkAlt = "plan-card-purple";
    }

    return (
        <div className={`plan-card plan-card-${bgColor} ${icons.length === 1 ? darkAlt : ""}`}>
            <div className="plan-card-header">
                <ul className="plan-card-header-icons">
                    {icons.map((icon, idx) => (
                    <li key={`plan-card-header-icons-${idx}`}>{icon}</li>
                    ))}
                </ul>
            </div>
            <div className="plan-card-content">
                <div className="plan-card-price">
                    <div className="pc-price-box">
                        <span dangerouslySetInnerHTML={{__html: plan.monthlyPricePrint}} />
                    </div>
                    <div className="pc-price-info">
                        <span className="pc-price-info-small">{t('Plan.monthly')} *</span>
                        <span className="pc-price-info-strong">{plan[planLabelField]}</span>
                    </div>
                </div>
                <div className="plan-card-info">
                    {plan[planInfoField].length > 0 && (
                    <ul>
                        {plan[planInfoField].map((item, idx) => (
                        <li key={`plan-card-info-${plan.id}-${idx}`}>
                            <FontAwesomeIcon icon={faCheck} style={{marginRight: 8}} />{item}
                        </li>
                        ))}
                    </ul>
                    )}
                </div>
            </div>
            {plan.planStep === 'SERVICE' && (
            <div className="plan-card-button">
                <Button
                    type="text"
                    className={`sur-btn sur-btn-${bgColor}`}
                    onClick={(e) => {
                        e.preventDefault()
                        nextStep(plan.apiCode, external);
                    }}>
                    {t('Plan.Subscribe Now')}
                    <FontAwesomeIcon icon={faArrowCircleRight} size="lg" style={{marginLeft: 12}} />
                </Button>
            </div>
            )}
        </div>
    );
}
